import React from "react";
import { Modal, Button } from "react-bootstrap";

const FOCUSABLE_SELECTOR = [
  "button:not([disabled])",
  "[href]",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
].join(",");

function ConfirmationModal({
  show,
  handleClose,
  handleConfirmChange,
  title = "Confirmation",
  message = "Are you sure you want to make this change?",
  confirmLabel = "Confirm",
  returnLabel = "Cancel",
  confirmVariant = "primary",
  returnVariant = "secondary",
  confirmFirst = false,
  centered = false,
}) {
  const confirmAction = (
    <Button variant={confirmVariant} onClick={handleConfirmChange}>
      {confirmLabel}
    </Button>
  );
  const returnAction = (
    <Button variant={returnVariant} onClick={handleClose}>
      {returnLabel}
    </Button>
  );
  const trapFocus = (event) => {
    if (event.key !== "Tab") return;
    const dialog = event.currentTarget.querySelector('[role="dialog"]') || event.currentTarget;
    const focusable = Array.from(dialog.querySelectorAll(FOCUSABLE_SELECTOR))
      .filter((element) => element.getAttribute("aria-hidden") !== "true");
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !dialog.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered={centered}
      enforceFocus
      restoreFocus
      onKeyDown={trapFocus}
    >
      <Modal.Header closeButton>
        <Modal.Title as="h2">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        {confirmFirst ? confirmAction : returnAction}
        {confirmFirst ? returnAction : confirmAction}
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;
